// global
import global from "../../assets/traslations/pt/global.json";

// auth
import forgot_pass from "../../assets/traslations/pt/auth/forgot_pass.json";
import login from "../../assets/traslations/pt/auth/login.json";
import profile from "../../assets/traslations/pt/auth/profile.json";
import register from "../../assets/traslations/pt/auth/register.json";
import reset_pass from "../../assets/traslations/pt/auth/reset_pass.json";
import validate_email from "../../assets/traslations/pt/auth/validate_email.json";

// master
import contact from "../../assets/traslations/pt/master/contact.json";
import client from "../../assets/traslations/pt/master/client.json";
import delivery from "../../assets/traslations/pt/master/delivery.json";
import driver from "../../assets/traslations/pt/master/driver.json";
import transport from "../../assets/traslations/pt/master/transport.json";
import operators from "../../assets/traslations/pt/master/operators.json";

// reports
import invoices from "../../assets/traslations/pt/reports/invoices.json";
import orders from "../../assets/traslations/pt/reports/orders.json";
import routeCost from "../../assets/traslations/pt/reports/routeCost.json";
import routes from "../../assets/traslations/pt/reports/routes.json";

// transactions
import order from "../../assets/traslations/pt/transactions/order.json";
import quote from "../../assets/traslations/pt/transactions/quote.json";
import route from "../../assets/traslations/pt/transactions/route.json";
import invoice from "../../assets/traslations/pt/transactions/invoice.json";

// config
import cost from "../../assets/traslations/pt/config/cost.json";
import transportBrand from "../../assets/traslations/pt/config/transportBrand.json";
import transportSupplier from "../../assets/traslations/pt/config/transportSupplier.json";


const pt = {
    // global
    global,

    // auth
    forgot_pass,
    login,
    profile,
    register,
    reset_pass,
    validate_email,

    // master
    contact,
    client,
    delivery,
    driver,
    transport,
    operators,

    // reports
    invoices,
    orders,
    routeCost,
    routes,

    // transactions
    order,
    quote,
    route,
    invoice,

    // config
    cost,
    transportBrand,
    transportSupplier,
}

export default pt;
